import {
  Col, Card, Input,
  CardBody, Row
} from 'reactstrap';
import 'rsuite/dist/rsuite.css';
import search from "../../../assets/images/search.png";
import { useEffect, useState } from 'react';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import 'bootstrap/dist/css/bootstrap.css';
import { ELIGIBILITY_INSTITUTE_ID } from '../../../helpers/eligibilityConfig';
import statusimage from "../../../assets/images/status.png";
import rightarrow from "../../../assets/images/chevron-right.png";
import { useNavigate } from 'react-router-dom';
import EditForm from '../EditForm/EditForm';
import MoveStatus from '../MoveStatus/MoveStatus';
import ResendConsent from '../ResendConsent/ResendConsent';
import download from "../../../assets/images/download.png";
import PaginationTable from '../PaginationTable';
import './ProjectTable.css';
import { useSelector, useDispatch } from "react-redux";
import * as moment from 'moment';
import { Tooltip } from "@mui/material";
import { userActions } from '../../../actions/user.actions';
import InstituteAutocomplete from '../../status/ProjectTable/InstituteSearch'
import {ApplicationStatusEnum} from '../../../data';
import { handleExcelDownload } from '../../../utils/excelDownload';
import { appContextConstants } from '../../../constants/appContext.constants';

import useApplicationData from '../../../hooks/useApplicationData';
import RefreshIcon from "@mui/icons-material/Refresh";
import { useCurrentUser } from '../../../hooks/useCurrentUser';
import SourceBadge from '../../shared/SourceBadge/SourceBadge';
require('moment/locale/fr');
require('moment/locale/de');
require('moment/locale/en-gb');

const ProjectTables = () => {

  const insubstate = useSelector((state) => state?.Insubmission?.res);
  const datestate = useSelector((state) => state.Datefilter?.res);
  const usersearchdefstate = useSelector((state) => state?.UserSearchDefault?.res?.data?.data);
  const usersearchinsstate = undefined;

  const dispatch = useDispatch();

  const decode = useCurrentUser();
  const user = null;

  const status = ApplicationStatusEnum.InSubmission;

  const [cra, newCra] = useState([]);

  const [instituteResetKey, setInstituteResetKey] = useState(0);
  const {
    tableData,
    productTypeSelected,
    currentPage,
    rowsPerPage,
    totalFetchRows,
    isLoading,
    filterDateFrom,
    filterDateTo,
    instituteId,
    instituteName,
    selectedCRA,
    activePage,

    setFilterDateFrom,
    setFilterDateTo,
    setInstituteId,
    setInstituteName,

    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    handleCRAChange,
    clearFilters,
  } = useApplicationData({
    status,
    user,
    dependencies: {
      insubstate,
      datestate,
      usersearchdefstate,
      usersearchinsstate,
    },
  });

  const valid = (current) => {
    return current.isAfter(filterDateFrom);
  };

  const navigate = useNavigate();

  const handleUser = (event) => {
    const Id = event.userId;
    const applId = event.applicationId;
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      appId: applId,
    }});

    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/submission/profile', {
      state: {
        id: 1,
        profileId: Id,
        applicantId: Id,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "In Submission"
      },
    });
  };

  const handleCoApp = (event) => {
    const Id = event.coapplicantId;
    const getActivityUrl = `/audit?applicationId=${event.applicationId}`;
    dispatch(userActions.getActivity(getActivityUrl, user));

    navigate('/status/submission/profile', {
      state: {
        id: 1,
        profileId: Id,
        clickEvent: "coapp",
        applicantId: event.userId,
        coapplicantId: event.coapplicantId,
        applicationId: event.applicationId,
        dir: "In Submission"
      },
    });
  };

  const handleApplicationProfile = (currApplicationId, currUID, currCoAppId) => {
    dispatch({ type: appContextConstants.SET_APP_CONTEXT, payload: {
      coappId: currCoAppId,
      userId: currUID,
      appId: currApplicationId,
    }});

    // const urlForApplicationDetails = `/admin/application/application-profile?applicationId=${sessionStorage.getItem("appId")}`;
    // const urlForBankSelfie = `/integrations/application-profile?applicationId=${sessionStorage.getItem("appId")}`;
    // const getEmiUrl = `/emis?applicationId=${sessionStorage.getItem("appId")}`;
    // const getActivityUrl = `/audit?applicationId=${sessionStorage.getItem("appId")}`;

    // dispatch(userActions.fetchUrlforApplicationdetails(urlForApplicationDetails, user), []);
    // dispatch(userActions.fetchUrlforbankselfie(urlForBankSelfie, user), []);
    // dispatch(userActions.fetchEmiUrl(getEmiUrl, user), []);
    // dispatch(userActions.getActivity(getActivityUrl, user));

    navigate("/status/disbursed/appProfile");
  };

  const handleDownloadList = () => {
    handleExcelDownload({
      status: status,
      instituteId: decode.instituteId ? decode.instituteId : instituteId,
      fromDate: filterDateFrom,
      toDate: filterDateTo,
      user: user,
      productType:productTypeSelected && productTypeSelected !== "all"? Number(productTypeSelected): undefined,
      downloadIcon: download,
      buttonId: 'downloadButton',
      buttonStyles: {
        width: '90px',
        marginLeft: '150px'
      }
    });
  };

  function formatNumberWithCommas(number) {
    return number.toLocaleString('en-IN');
  }

  const handleChange = (event) => {
    handleCRAChange(event.target.value);
  };
useEffect(() => {
  window.addEventListener("beforeunload", () => 
    sessionStorage.removeItem("TableFilters")
  );
}, []);
  if (tableData) {
    return (
      <Card className='card' style={{ width: "100%", height: '100%' }}>
          <CardBody className='card-body'>
            <div>
              <p style={{ display: 'flex', alignItems: 'center' }}>
                <img src={statusimage} alt="" />
                <span style={{ fontFamily: 'Inter-Medium', marginLeft: '10px', fontSize: '14px' }}>status</span>
                <span style={{ marginLeft: '20px', marginBottom: '3px' }}>
                  <img style={{ height: "18px", width: "14px" }} src={rightarrow} alt="" />
                </span>
                <span style={{ fontFamily: 'Inter-Medium', marginLeft: '10px', fontSize: '14px', color: '#D32028' }}>
                  {status}
                </span>
              </p>
            </div>

            <Row>
              <div style={{ display: 'flex', flex: 'wrap' }}>
                <Col sm="12" md="10" lg="3">
                  <div
                    style={{
                      height: '23px',
                      marginRight: '10px',
                      fontFamily: 'Inter',
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    {decode.role === "institute_admin" || decode.role === "institute_user" || decode.role === "institute_cra" ? (
                      <Input
                        type="text"
                        id="userSearch"
                        value={decode.instituteName}
                        readOnly
                        disabled
                        placeholder={'Merchant Name'}
                        style={{
                          fontSize: '0.8vw',
                          paddingLeft: '26px',
                          fontFamily: 'Inter',
                          backgroundImage: `url(${search})`,
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: '5px center',
                          backgroundSize: '15px 15px',
                          paddingRight: '5px',
                          borderColor: '#cccccc',
                          borderStyle: 'solid',
                          borderRadius: "5px",
                          borderWidth: '1px',
                          height: '34px',
                          marginTop: '11px'
                        }}
                      />
                    ) : (
                      <InstituteAutocomplete
                          key={instituteResetKey}
                        onInstituteSelect={(id,name) =>{ 
                          setInstituteId(id)
                          setInstituteName(name || "");
                        }}
                          defaultValue={instituteName}
                        searchIcon={search}
                        placeholder={
                          decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                            ? 'Product Type'
                            : 'Merchant Name'
                        }
                      />
                    )}
                  </div>
                </Col>

                <Col>
                  <div style={{ height: '7px', marginRight: '10px', marginLeft: '12px' }}>
                    <Datetime
                      key={`fromDate-${filterDateFrom || "empty"}`}
                      closeOnSelect="false"
                      id="fromDate"
                      dateFormat="DD MMM YYYY"
                      timeFormat={false}
                      value={filterDateFrom ? moment(filterDateFrom, "DD MMM YYYY") : null}
                      onChange={(event) => {
                        if (event && event.format) {
                          setFilterDateFrom(event.format('DD MMM YYYY'));
                        } else {
                          setFilterDateFrom(null);
                        }
                      }}
                      locale="en-gb"
                      inputProps={{ placeholder: 'From Date', style: { fontFamily: 'Inter', fontSize: "14px" } }}
                    />
                  </div>
                </Col>

                <Col>
                  <div style={{ height: '7px', marginRight: '10px' }}>
                    <Datetime
                      key={`toDate-${filterDateTo || "empty"}`}
                      closeOnSelect="false"
                      id="toDate" 
                      dateFormat="DD MMM YYYY"
                      isValidDate={valid}
                      timeFormat={false}
                      locale="en-gb"
                      initialViewDate={         
                        filterDateFrom
                          ? moment(filterDateFrom, 'DD MMM YYYY')
                          : moment()
                      }
                      onChange={(event) => {
                        if (event && event.format) {
                          setFilterDateTo(event.format('DD MMM YYYY'));
                        } else {
                          setFilterDateTo(null);
                        }
                      }}
                      value={filterDateTo ? moment(filterDateTo, "DD MMM YYYY") : null}
                      inputProps={{ placeholder: 'To Date', style: { fontFamily: 'Inter', fontSize: "14px" } }}
                    />
                  </div>
                </Col>

                <Col>
                  <div>
                    <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        width: '130px',
                        backgroundColor: '#D22129',
                        height: '34px',
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter",
                        paddingLeft: '10px'
                      }}
                      onClick={handleSearch}
                    >
                      Search Results
                    </button>
                  </div>
                </Col>
                <Col>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <button
                      onClick={() => {
                        clearFilters();
                        setInstituteResetKey((prev) => prev + 1);
                      }}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "34px",
                        width: "42px",
                        backgroundColor: "#D22129",
                        border: "none",
                        borderRadius: "5px",
                        color: "white",
                        cursor: "pointer",
                        marginLeft:'10px'
                      }}
                    >
                      <RefreshIcon />
                    </button>
                  </div>
                </Col>
                {decode.role === "institute_admin" ||
                decode.role === "institute_user" ||
                decode.role === "channel_user" ? null : (
                  <Col>
                    <div>
                      {/* CRA filter (still commented out)
                      <Input
                        type="select"
                        name="select"
                        id="exampleSelect"
                        value={selectedCRA}
                        onChange={handleChange}
                      >
                        <option value="">Select CRA</option>
                        {cra?.map((item, index) => (
                          <option key={item.id || index}>{item.name}</option>
                        ))}
                      </Input>
                      */}
                    </div>
                  </Col>
                )}

                {(decode.role === "cra" ||
                  decode.role === "crsa" ||
                  decode.role === "institute_cra" ||
                  (decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" &&
                    decode.role === "institute_user")) ? (
                  ""
                ) : (
                  <Col>
                    <button
                      style={{
                        backgroundColor: '#D22129',
                        width: '90px',
                        height: '34px',
                        padding: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        marginLeft: "150px",
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter"
                      }}
                      id="downloadButton"
                      onClick={handleDownloadList}
                    >
                      <p
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginTop: '15px'
                        }}
                      >
                        <img
                          style={{ height: '15px', alignItems: "center", marginRight: '5px' }}
                          src={download}
                          alt="download"
                        />
                        <span>Export</span>
                      </p>
                    </button>
                  </Col>
                )}
              </div>
            </Row>

            {isLoading ? (
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '15%',
                  backgroundColor: 'white',
                  height: '100vh'
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                <div className='tables' style={{ marginTop: '20px' }}>
                  <table>
                    <thead className='table-heading'>
                      <tr>
                        <th
                          style={{
                            fontSize: '14px',
                            cursor: 'pointer',
                            width: '15%',
                            fontFamily: "Inter",
                            borderTopLeftRadius: '8px'
                          }}
                          id="appId"
                        >
                          <span style={{ marginLeft: '10px' }}></span> Appl. Id
                        </th>
                        <th
                          style={{ fontSize: '14px', fontFamily: "Inter", width: '20%' }}
                          id="appname"
                        >
                          <span style={{ marginLeft: '10px' }}></span> Appl. Name
                        </th>
                        {(decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user") &&
                        decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? (
                          <th
                            style={{ fontSize: '14px', fontFamily: "Inter", width: '15%' }}
                            id="appname"
                          >
                            <span style={{ marginLeft: '10px' }}></span> Student Name
                          </th>
                        ) : null}
                        {decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' ? (
                          <th
                            style={{ fontSize: '14px', fontFamily: "Inter", width: '20%' }}
                            id="insName"
                          >
                            <span style={{ marginLeft: '10px' }}>Loan Type</span>
                          </th>
                        ) : (
                          <th
                            style={{ fontSize: '14px', fontFamily: "Inter", width: '20%' }}
                            id="insName"
                          >
                            <span style={{ marginLeft: '10px' }}>Merchant Name</span>
                          </th>
                        )}
                        {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
                          <th
                            style={{ fontSize: '14px', fontFamily: "Inter", width: '15%' }}
                            id="coursename"
                          >
                            <span style={{ marginLeft: '10px' }}>Course</span>
                          </th>
                        )}
                        <th
                          style={{ fontSize: '14px', width: '15%', cursor: 'pointer', fontFamily: "Inter" }}
                          id="appfromdate"
                        >
                          <span style={{ marginLeft: '10px' }}></span> Date
                        </th>
                        <th
                          style={{ fontSize: '14px', textAlign: 'center', fontFamily: "Inter", width: '15%' }}
                          id="cra"
                        >
                          CRA
                        </th>
                        <th
                          style={{ fontSize: '14px', fontFamily: "Inter", width: '8rem' }}
                          id="amt"
                        >
                          <span style={{ marginLeft: '10px' }}></span> Amount
                        </th>
                        <th
                          style={{ fontSize: '14px', fontFamily: "Inter" }}
                          id="actions"
                          className="thead-text"
                        >
                          <span style={{ marginLeft: '10px' }}></span> Actions
                        </th>
                      </tr>
                    </thead>
                    {tableData.map((item) => (
                      <tbody className='table-body' key={item.applicationId}>
                        <tr className="table-row" style={{ lineHeight: '20px' }}>
                          {decode.role !== "institute_user" &&
                          decode.role !== "institute_admin" &&
                          decode.role !== "channel_user" ? (
                            <td>
                              <span
                                onClick={() =>
                                  handleApplicationProfile(
                                    item.applicationId,
                                    item.userId,
                                    item.coapplicantId
                                  )
                                }
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '14px',
                                  fontWeight: '500',
                                  fontFamily: 'Inter',
                                  width: '8rem',
                                  lineHeight:'1.4em',
                                  color:'#667085'
                                }}
                              >
                                {item.applicationId}
                              </span>
                            </td>
                          ) : (
                            <td
                              style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                width: '10rem',
                                fontFamily: "Inter"
                              }}
                            >
                              {decode.role === "institute_user" &&
                              decode.instituteId === "9d5eca4b-54f7-42a7-8794-1413e00b462e" ? (
                                <Tooltip
                                  title={item.studentId ? item.studentId : "No StudentId"}
                                  arrow
                                >
                                  {item.applicationId}
                                </Tooltip>
                              ) : (
                                <>{item.applicationId}</>
                              )}
                            </td>
                          )}

                          {decode.role === "institute_user" ||
                          decode.role === "institute_admin" ||
                          decode.role === "channel_user" ? (
                            <td
                              style={{
                                fontSize: '14px',
                                fontFamily: "Inter",
                                width: '15rem',
                                fontWeight: "500",
                              lineHeight:'1.4em',
                                  color:'#667085'
                              }}
                              title={item.name || '-'}
                            >
                              <span
                                title={item.name}
                                style={{
                                   width: '15em',
                                fontFamily: "Inter",
                                fontWeight: '400',
                                color: '#667085',
                                fontSize: '14px',
                                lineHeight: '1.5em',
                                display: "block",
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                                }}
                              >
                                {item?.name
                                  ?.toLowerCase()
                                  .split(' ')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                  .join(' ')}
                              </span>
                              <br />
                              {item.coapplicantName ? (
                                <span
                                  title={item.coapplicantName}
                                  style={{
                                    fontSize: '14px',
                                    fontFamily: "Inter",
                                    fontWeight: "500",
                                    display: "inline-block",
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    lineHeight:'1.4em',
                                  color:'#667085'
                                  }}
                                >
                                  {item?.coapplicantName
                                    ?.toLowerCase()
                                    .split(' ')
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(' ')}{' '}
                                  ( C )
                                  <div className="forInstituteDetails">
                                    <span>{item.coapplicantEmail}</span>
                                    <span>{item.coapplicantMobile}</span>
                                  </div>
                                </span>
                              ) : (
                                ''
                              )}
                            </td>
                          ) : (
                            <td>
                              <span
                                title={item.name}
                                style={{
                                  width: '15rem',
                                  fontFamily: "Inter",
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  display: "block",
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  cursor: 'pointer',
                                  lineHeight:'1.4em',
                                  color:'#667085'
                                }}
                                onClick={() => handleUser(item)}
                              >
                                {item?.name
                                  ?.toLowerCase()
                                  .split(' ')
                                  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                  .join(' ')}
                              </span>
                              {item.coapplicantName ? (
                                <span
                                  title={item.coapplicantName}
                                  style={{
                                    width: '15rem',
                                    fontFamily: "Inter",
                                    fontWeight: '400',
                                    color: '#101828',
                                    fontSize: '14px',
                                    display: "block",
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    cursor: 'pointer',
                                    marginTop: '0.5rem'
                                  }}
                                  onClick={() => handleCoApp(item)}
                                >
                                  {item?.coapplicantName
                                    ?.toLowerCase()
                                    .split(' ')
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(' ')}{' '}
                                  ( C )
                                </span>
                              ) : (
                                ''
                              )}
                            </td>
                          )}

                          {(decode.role === "institute_user" ||
                            decode.role === "institute_admin" ||
                            decode.role === "channel_user") &&
                          decode.instituteId === "0f25fafd-77c0-4c05-9cf1-1b238f5eebd3" ? (
                            <td title={item.studentName}>
                              <span
                                style={{
        width: '15em',
        fontFamily: "Inter",
        fontWeight: '400',
        color: '#667085',
        fontSize: '14px',
        lineHeight: '1.5em',
        display: "block",
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }}
                              >
                                {item.studentName ? item.studentName : "-"}
                              </span>
                            </td>
                          ) : null}

                          <td>
                            <div className="merchant-with-source">
                              <span
                                title={item.instituteName}
                                style={{
                                  maxWidth: '10rem',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  color: '#667085',
                                  fontFamily: "Inter",
                                  display: "block",
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {item.instituteName ? item.instituteName : "-"}
                              </span>
                              {item.productType === 2 && (
                                <SourceBadge attribution={item.attribution} repeat={item.repeat} />
                              )}
                            </div>
                          </td>

                          {decode?.clientId !== '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361' && (
                            <td title={item.courseName}>
                              <span
                                style={{
                                  width: '10rem',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  color: '#667085',
                                  fontFamily: "Inter",
                                  display: "block",
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                              >
                                {item.courseName ? item.courseName : "-"}
                              </span>
                            </td>
                          )}

                          <td title={item.applicationDate?.substr(10, 14)}>
                            <span
                              style={{
                                width: '11rem',
                                fontWeight: '400',
                                fontSize: '14px',
                                color: '#667085',
                                fontFamily: "Inter"
                              }}
                            >
                              {item.applicationDate?.substr(0, 10)
                                ? moment(item.applicationDate?.substr(0, 10)).format('DD MMM YY')
                                : "-"}
                            </span>
                          </td>

                          <td
                            title={item.cra}
                            style={{
                              fontSize: '14px',
                              fontWeight: '500',
                              textAlign: 'center',
                              width: 'auto',
                              fontFamily: "Inter",
                              color: '#667085'
                            }}
                          >
                            {item.cra
                              ? item.cra[0] +
                                item.cra?.toUpperCase().substr(
                                  item.cra?.indexOf(" "),
                                  item.cra?.indexOf("") + 2
                                )
                              : null}
                          </td>

                          <td
                            style={{
                              marginLeft: '15px',
                              fontSize: '14px',
                              width: '8rem',
                              fontFamily: "Inter",
                              color: '#667085'
                            }}
                          >
                            {item.courseFees ? (
                              <>
                                &#8377;{formatNumberWithCommas(item.courseFees)}
                              </>
                            ) : (
                              '-'
                            )}
                          </td>

                          <td>
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between'
                              }}
                            >
                              {decode.role === "institute_user" ||
                              decode.role === "institute_admin" ||
                              decode.role === "user" ||
                              decode.role === "channel_user" ? null : (
                                <>
                                  <span
                                    title="Edit Form"
                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                  >
                                    <EditForm curruser={item} />
                                  </span>

                                  <span
                                    title="Move Status"
                                    style={{ cursor: 'pointer', marginRight: '10px' }}
                                  >
                                    <MoveStatus ApplicantId={item} showAssignOptions={item.channel === 6} />
                                  </span>
                                </>
                              )}
                              <span
                                title="Resend Consent"
                                style={{
                                  cursor: 'pointer',
                                  paddingRight: '10px',
                                  marginLeft:
                                    decode.role === "institute_user" ||
                                    decode.role === "institute_admin" ||
                                    decode.role === "user" ||
                                    decode.role === "channel_user"
                                      ? "20px"
                                      : "0px"
                                }}
                              >
                                <ResendConsent userInfo={item} />
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>

                {totalFetchRows ? (
                  totalFetchRows <= 100 ? (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                      <div
                        style={{
                          textAlign: 'center',
                          fontWeight: 'bold',
                          fontFamily: "Inter",
                          fontSize: '1vw',
                          marginLeft: '10px',
                          marginBottom: '5px'
                        }}
                      >
                        Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-
                        {currentPage * rowsPerPage - rowsPerPage + tableData?.length}{" "}
                        records of {totalFetchRows} |
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        &nbsp;
                        <p style={{ fontWeight: '600' }}>Rows Per Pages :</p>
                        <div>
                          <span
                            onClick={() => handleRowsPerPageChange(15)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 15 ? "#D32028" : "black",
                              backgroundColor: activePage === 15 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            15
                          </span>
                          <span
                            onClick={() => handleRowsPerPageChange(50)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 50 ? "#D32028" : "black",
                              backgroundColor: activePage === 50 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            50
                          </span>
                          <span
                            onClick={() => handleRowsPerPageChange(100)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 100 ? "#D32028" : "black",
                              backgroundColor: activePage === 100 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            100
                          </span>
                          <span
                            onClick={() => handleRowsPerPageChange(500)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 500 ? "#D32028" : "black",
                              backgroundColor: activePage === 500 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            500
                          </span>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div style={{ display: "flex", justifyContent: "center", marginTop: "10px" }}>
                      <div
                        style={{
                          textAlign: 'center',
                          fontWeight: 'bold',
                          justifyContent: "space-between",
                          fontFamily: "Inter-Medium",
                          fontSize: '1vw',
                          marginLeft: '10px',
                          marginBottom: '5px',
                          marginRight: '10px'
                        }}
                      >
                        Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-
                        {currentPage * rowsPerPage - rowsPerPage + tableData?.length}{" "}
                        records of {totalFetchRows} |
                      </div>
                      <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <p style={{ fontWeight: '600' }}>Rows Per Pages :</p>
                        <div>
                          <span
                            onClick={() => handleRowsPerPageChange(15)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 15 ? "#D32028" : "black",
                              backgroundColor: activePage === 15 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            15
                          </span>
                          <span
                            onClick={() => handleRowsPerPageChange(50)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 50 ? "#D32028" : "black",
                              backgroundColor: activePage === 50 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            50
                          </span>
                          <span
                            onClick={() => handleRowsPerPageChange(100)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 100 ? "#D32028" : "black",
                              backgroundColor: activePage === 100 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            100
                          </span>
                          <span
                            onClick={() => handleRowsPerPageChange(500)}
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              color: activePage === 500 ? "#D32028" : "black",
                              backgroundColor: activePage === 500 ? "#FFF2F3" : "",
                              borderRadius: '8px'
                            }}
                          >
                            500
                          </span>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div
                    style={{
                      textAlign: 'center',
                      fontWeight: 'bold',
                      fontFamily: "Inter",
                      fontSize: '14px'
                    }}
                  >
                    No Records
                  </div>
                )}

                <PaginationTable
                  startPage={currentPage}
                  rowsPerPage={rowsPerPage}
                  totalRows={totalFetchRows}
                  paginate={handlePageChange}              
                  handlepageChange={handleRowsPerPageChange} 
                  filterDateFrom={filterDateFrom}
                />
              </>
            )}
          </CardBody>
      </Card>
    );
  }

  return <div>....Loading</div>;
};

export default ProjectTables;
